export default __webpack_public_path__ + "static/win_logo-f39d45b8205491f195f429cb8194afb7.png";